module.exports = __webpack_public_path__ + "static/img_9633-bb31d96163b8467cbde17f2854f7c3e1.webp";